<div *ngIf="form && this.entity" class="flex flex-col justify-between h-full min-h-0 gap-8 p-4">
  <form [formGroup]="form" class="flex flex-col h-full min-h-0">
    <div class="top-panel flex flex-row justify-between items-center" *ngIf="langCode$ | async as langCode">
      <div class="row flex gap-2 mt-2 justify-center">
        <dx-button text="{{ 'hr.attendanceDayView.entryIn' | translate }}" type="default" icon="arrowright"
          [disabled]="!entity.workerId" (onClick)="createEntryIn()"></dx-button>
        <dx-button text="{{ 'hr.attendanceDayView.entryOut' | translate }}" type="default" icon="arrowleft"
          [class]="(!entity.workerId) ? '' : '!bg-red-600 !text-white hover:!bg-red-700 focus:!bg-red-700'"
          [disabled]="!entity.workerId" (onClick)="createEntryOut()"></dx-button>
      </div>
    </div>

    <div class="flex flex-col flex-1 min-h-0">
      <div class="content flex flex-1 gap-8 min-h-0" *ngIf="langCode$ | async as langCode">
        <!-- Columna esquerra -->
        <div class="left-panel flex-1 min-w-[600px] min-h-0">
          <dx-data-grid #todayEntriesGrid class="h-full" height="100%" [glamResource]="clockingResource"
            [disabledAdd]="true" [showBorders]="true" [disabledDelete]="!entity.workerId"
            [groupPanel]="{ visible: false }" [searchPanel]="{ visible: false }" (onCellClick)="onCellClick($event)"
            (onCellPrepared)="onTodayEntriesCellPrepared($event)">
            <dxo-filter-row [visible]="false"></dxo-filter-row>

            <dxi-column cellTemplate="dateCell" dataField="day" caption="{{ 'hr.attendanceDayView.date' | translate }}"
              dataType="date" [allowEditing]="false">
              <div *dxTemplate="let item of 'dateCell'">
                <span *ngIf="entity.workerId" class="hover:underline cursor-pointer">
                  {{ (item.data.day || item.data.entryOut) | date:'EEEE dd/MM/yyyy':undefined:langCode | ucfirst }}
                </span>
                <span *ngIf="!entity.workerId">
                  {{ (item.data.day || item.data.entryOut) | date:'EEEE dd/MM/yyyy':undefined:langCode | ucfirst }}
                </span>
              </div>
            </dxi-column>

            <dxi-column dataField="entryIn" caption="{{ 'entity.attendanceEntry.entryIn' | translate }}"
              dataType="datetime" [allowEditing]="(entity.workerId)" cellTemplate="entryInCell">
              <div *dxTemplate="let item of 'entryInCell'">
                <span *ngIf="entity.workerId" class="hover:underline cursor-pointer">
                  {{ item.data.entryIn | date:'shortTime':undefined:langCode }}
                </span>
                <span *ngIf="!entity.workerId">
                  {{ item.data.entryIn | date:'shortTime':undefined:langCode }}
                </span>
              </div>
            </dxi-column>

            <dxi-column dataField="entryOut" caption="{{ 'entity.attendanceEntry.entryOut' | translate }}"
              dataType="datetime" [allowEditing]="(entity.workerId)" cellTemplate="entryOutCell">
              <div *dxTemplate="let item of 'entryOutCell'">
                <span *ngIf="entity.workerId" class="hover:underline cursor-pointer">
                  {{ item.data.entryOut | date:'shortTime':undefined:langCode }}
                </span>
                <span *ngIf="!entity.workerId">
                  {{ item.data.entryOut | date:'shortTime':undefined:langCode }}
                </span>
              </div>
            </dxi-column>

            <dxi-column [allowEditing]="false" dataField="attendanceTime"
              caption="{{ 'entity.attendanceEntry.attendanceTime' | translate }}" cellTemplate="attendanceTimeCell">
              <div *dxTemplate="let item of 'attendanceTimeCell'">
                <span *ngIf="item.data.entryOut === null || item.data.entryOut === undefined"
                  class="w-min min-w-[100px] text-left">{{ secondsToHhmmss(item.data.openedAttendanceTime | async)
                  }}</span>
                <span *ngIf="item.data.entryOut !== null && item.data.entryOut !== undefined"
                  class="w-min min-w-[100px] text-left">{{ secondsToHhmmss(item.data.attendanceTime) }}</span>
              </div>
            </dxi-column>

            <dxi-column [allowEditing]="false" dataField="incidence"
              caption="{{ 'entity.attendanceEntry.incidence' | translate }}" dataType="boolean"
              cellTemplate="stateCellTpl">
              <div *dxTemplate="let cell of 'stateCellTpl'" class="flex justify-center items-center w-full min-h-full">
                <gs-entity-state-label [entity]="cell.data" [fieldName]="cell.column.dataField"
                  [resource]="$any(incidencesResource!)" />
              </div>
            </dxi-column>

            <dxi-column dataField="openedAttendanceTime" [visible]="false"></dxi-column>

            <dxo-summary>
              <dxi-total-item column="attendanceTime" summaryType="sum" [customizeText]="formatTodayAttendanceFooter" />
            </dxo-summary>

          </dx-data-grid>
        </div>

        <!-- Columna dreta -->
        <div class="right-panel flex-[2] min-w-[600px] min-h-0">
          <dx-data-grid #weekEntriesGrid #glamResourceDir="glamResource" class="h-full week-nav-toolbar-grid"
            height="100%" [glamResource]="weekNavigatorResource" [disabledAdd]="!entity.workerId"
            [disabledDelete]="!entity.workerId" [createComponent]="entriesAddComponent"
            [customParams]="{workerId: entity.workerId}" [showBorders]="true" [groupPanel]="{ visible: false }"
            [searchPanel]="{ visible: false }" (onCellClick)="onCellClick($event)"
            [customToolbarItemsAfter]="weekNavToolbar">
            <dxo-filter-row [visible]="false"></dxo-filter-row>

            <dxi-column cellTemplate="dateCell" dataField="day" caption="{{ 'hr.attendanceDayView.date' | translate }}"
              dataType="date" [allowEditing]="false">
              <div *dxTemplate="let item of 'dateCell'">
                <span *ngIf="entity.workerId" class="hover:underline cursor-pointer">
                  {{ (item.data.day || item.data.entryOut) | date:'EEEE dd/MM/yyyy':undefined:langCode | ucfirst }}
                </span>
                <span *ngIf="!entity.workerId">
                  {{ (item.data.day || item.data.entryOut) | date:'EEEE dd/MM/yyyy':undefined:langCode | ucfirst }}
                </span>
              </div>
            </dxi-column>

            <dxi-column dataField="entryIn" caption="{{ 'entity.attendanceEntry.entryIn' | translate }}"
              dataType="datetime" [allowEditing]="(entity.workerId)" cellTemplate="entryInCellWeek">
              <div *dxTemplate="let item of 'entryInCellWeek'">
                <span *ngIf="entity.workerId" class="hover:underline cursor-pointer">
                  {{ item.data.entryIn | date:'shortTime':undefined:langCode }}
                </span>
                <span *ngIf="!entity.workerId">
                  {{ item.data.entryIn | date:'shortTime':undefined:langCode }}
                </span>
              </div>
            </dxi-column>

            <dxi-column dataField="entryOut" caption="{{ 'entity.attendanceEntry.entryOut' | translate }}"
              dataType="datetime" [allowEditing]="(entity.workerId)" cellTemplate="entryOutCellWeek">
              <div *dxTemplate="let item of 'entryOutCellWeek'">
                <span *ngIf="entity.workerId" class="hover:underline cursor-pointer">
                  {{ item.data.entryOut | date:'shortTime':undefined:langCode }}
                </span>
                <span *ngIf="!entity.workerId">
                  {{ item.data.entryOut | date:'shortTime':undefined:langCode }}
                </span>
              </div>
            </dxi-column>

            <dxi-column [allowEditing]="false" dataField="attendanceTime"
              caption="{{ 'entity.attendanceEntry.attendanceTime' | translate }}" cellTemplate="attendanceTimeCellWeek">
              <div *dxTemplate="let item of 'attendanceTimeCellWeek'">
                <span class="w-min min-w-[100px] text-left">{{ secondsToHhmmss(item.data.attendanceTime) }}</span>
              </div>
            </dxi-column>

            <dxi-column [allowEditing]="false" dataField="incidence"
              caption="{{ 'entity.attendanceEntry.incidence' | translate }}" dataType="boolean"
              cellTemplate="stateCellTpl">
              <div *dxTemplate="let cell of 'stateCellTpl'" class="flex justify-center items-center w-full min-h-full">
                <gs-entity-state-label [entity]="cell.data" [fieldName]="cell.column.dataField"
                  [resource]="$any(incidencesResource!)" />
              </div>
            </dxi-column>

            <dxo-summary>
              <dxi-total-item column="attendanceTime" summaryType="sum" [customizeText]="formatSummaryAttendanceTime" />
            </dxo-summary>

          </dx-data-grid>
        </div>
      </div>

      <!-- Zona inferior -->
      <div class="bottom-panel flex-1 min-h-0 overflow-hidden mt-5" *ngIf="langCode$ | async as langCode">
        <div class="dx-theme-accent-as-text-color">
          {{ 'hr.attendanceDayView.incidencesList' | translate | ucfirst }}
        </div>
        <dx-data-grid #incidencesGrid class="h-full" height="100%" [glamResource]="incidencesResource"
          [hideToolbar]="true" [disabledAdd]="true" [disabledDelete]="!entity.workerId" [showBorders]="true"
          [groupPanel]="{ visible: false }" [searchPanel]="{ visible: false }" (onCellClick)="onCellClick($event)">
          <dxo-filter-row [visible]="false"></dxo-filter-row>
          <dxo-scrolling mode="virtual"></dxo-scrolling>

          <dxi-column cellTemplate="dateCell" dataField="day" caption="{{ 'hr.attendanceDayView.date' | translate }}"
            dataType="date" [allowEditing]="false">
            <div *dxTemplate="let item of 'dateCell'">
              <span *ngIf="entity.workerId" class="hover:underline cursor-pointer">
                {{ (item.data.day || item.data.entryOut) | date:'EEEE dd/MM/yyyy':undefined:langCode | ucfirst }}
              </span>
              <span *ngIf="!entity.workerId">
                {{ (item.data.day || item.data.entryOut) | date:'EEEE dd/MM/yyyy':undefined:langCode | ucfirst }}
              </span>
            </div>
          </dxi-column>

          <dxi-column dataField="entryIn" caption="{{ 'entity.attendanceEntry.entryIn' | translate }}"
            dataType="datetime" [allowEditing]="(entity.workerId)" cellTemplate="entryInCell">
            <div *dxTemplate="let item of 'entryInCell'">
              <span *ngIf="entity.workerId" class="hover:underline cursor-pointer">
                {{ item.data.entryIn | date:'shortTime':undefined:langCode }}
              </span>
              <span *ngIf="!entity.workerId">
                {{ item.data.entryIn | date:'shortTime':undefined:langCode }}
              </span>
            </div>
          </dxi-column>

          <dxi-column dataField="entryOut" caption="{{ 'entity.attendanceEntry.entryOut' | translate }}"
            dataType="datetime" [allowEditing]="(entity.workerId)" cellTemplate="entryOutCell">
            <div *dxTemplate="let item of 'entryOutCell'">
              <span *ngIf="entity.workerId" class="hover:underline cursor-pointer">
                {{ item.data.entryOut | date:'shortTime':undefined:langCode }}
              </span>
              <span *ngIf="!entity.workerId">
                {{ item.data.entryOut | date:'shortTime':undefined:langCode }}
              </span>
            </div>
          </dxi-column>

          <dxi-column [allowEditing]="false" dataField="attendanceTime"
            caption="{{ 'entity.attendanceEntry.attendanceTime' | translate }}" cellTemplate="attendanceTimeCell">
            <div *dxTemplate="let item of 'attendanceTimeCell'">
              <span class="w-min min-w-[100px] text-left">{{ secondsToHhmmss(item.data.attendanceTime) }}</span>
            </div>
          </dxi-column>

          <dxi-column [allowEditing]="false" dataField="incidence"
            caption="{{ 'entity.attendanceEntry.incidence' | translate }}" dataType="boolean"
            cellTemplate="stateCellTpl">
            <div *dxTemplate="let cell of 'stateCellTpl'" class="flex justify-center items-center w-full min-h-full">
              <gs-entity-state-label [entity]="cell.data" [fieldName]="cell.column.dataField"
                [resource]="$any(incidencesResource!)" />
            </div>
          </dxi-column>
        </dx-data-grid>
      </div>
    </div>
  </form>
</div>

<dx-popup *ngIf="editPopupVisible && selectedEntryForEdit" [(visible)]="editPopupVisible" [showCloseButton]="true"
  [showTitle]="true" [title]="'entity.attendanceEntry.attendanceEntry' | translate" [width]="'420px'" height="auto"
  [hideOnOutsideClick]="true" (onHidden)="onEditPopupHidden()">
  <app-hr-attendance-entries-edit-popup *ngIf="editPopupVisible && selectedEntryForEdit" [entity]="selectedEntryForEdit"
    (edited)="updateEditedEntry($event)"></app-hr-attendance-entries-edit-popup>
</dx-popup>